import React from "react";
import config from "../config.json";
import { FiFacebook, FiPhone, FiMail } from "react-icons/fi";
import { LineIcon } from "./icon";

const { email, phone, social } = config.contact;

export default function Footer() {
  const now = new Date();
  return (
    <footer
      className="bg-neutral-primary"
      style={{ backgroundColor: "#f0f8ff" }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <div className="px-4 py-6 bg-neutral-secondary-soft md:flex md:items-center md:justify-between">
          <span className="text-sm text-body sm:text-center">
            © {now.getFullYear()}{" "}
            <a target="_blank" href="https://microplusleasing.com/">
              Microplusleasing™
            </a>
            . All Rights Reserved.
          </span>
          <div className="flex mt-4 sm:justify-center md:mt-0 space-x-2 rtl:space-x-reverse">
            <a
              href={social.facebook}
              target="_blank"
              className="text-body hover:text-heading"
            >
              <FiFacebook size={24} />
              <span className="sr-only">Facebook page</span>
            </a>
            <a
              href={social.line}
              target="_blank"
              className="text-body hover:text-heading"
            >
              <LineIcon size={24} />
              <span className="sr-only">Line Official</span>
            </a>
            <a
              href={`tel:${phone.call_center}`}
              className="text-body hover:text-heading"
            >
              <FiPhone size={24} />
              <span className="sr-only">Phone</span>
            </a>
            <a
              href={`mailto:${email.contact}`}
              className="text-body hover:text-heading"
            >
              <FiMail size={24} />
              <span className="sr-only">Email</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
